const googleMapInit = () => {
    const maps = Array.from(document.querySelectorAll('.bn-google-map'));

    function initMap(el) {
        const styles = [
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#d3d3d3"
                    }
                ]
            },
            {
                "featureType": "transit",
                "stylers": [
                    {
                        "color": "#808080"
                    },
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#b3b3b3"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ffffff"
                    },
                    {
                        "weight": 1.8
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#d7d7d7"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#a7a7a7"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#efefef"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#696969"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#737373"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#d6d6d6"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#dadada"
                    }
                ]
            }
        ];

        const markers = el.querySelectorAll('.marker');

        const mapArgs = {
            zoom: el.dataset.zoom || 16,
            mapTypeId: "roadmap",
            styles: styles,
            disableDefaultUI: true,
        };
        const map = new google.maps.Map(el, mapArgs);

        map.markers = [];
        markers.forEach(function (marker) {
            initMarker(marker, map);
        });

        centerMap(map);

        return map;
    }

    /**
     * initMarker
     *
     * Creates a marker for the given element and map.
     *
     * @param   HTMLElement marker The marker element.
     * @param   object map The map instance.
     * @return  object The marker instance.
     */
    function initMarker(marker, map) {
        // Get position from marker.
        const lat = parseFloat(marker.dataset.lat.replace(',', '.'));
        const lng = parseFloat(marker.dataset.lng.replace(',', '.'));

        const latLng = { lat: lat, lng: lng };

        const markerSetting = {
            position: latLng,
            map: map,
        };

        if (marker.dataset.icon) {
            markerSetting.icon = {
                url: marker.dataset.icon,
                scaledSize: new google.maps.Size(181, 78),
                anchor: new google.maps.Point(90, 59),
            };
        }

        const googleMarker = new google.maps.Marker(markerSetting);

        map.markers.push(googleMarker);

        // If marker contains HTML, add it to an infoWindow.
        if (marker.innerHTML.trim()) {
            // Create info window.
            const infowindow = new google.maps.InfoWindow({
                content: marker.innerHTML,
            });

            // Show info window when marker is clicked.
            googleMarker.addListener('click', function () {
                infowindow.open(map, googleMarker);
            });
        }
    }

    /**
     * Centers the map showing all markers in view.
     *
     * @param   object map The map instance.
     * @return  void
     */
    function centerMap(map) {
        const bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function (marker) {
            bounds.extend({
                lat: marker.position.lat(),
                lng: marker.position.lng(),
            });
        });

        if (map.markers.length === 0) {
            map.setCenter({ lat: 52.2297, lng: 21.0122 });
        } else if (map.markers.length === 1) {
            map.setCenter(bounds.getCenter());
        } else {
            map.fitBounds(bounds);
        }
    }

    if (maps) {
        maps.forEach(map => {
            initMap(map);
        });
    }
}

const bootGoogleMap = () => {
    if (!document.body || document.body.classList.contains('block-editor-page') || document.body.classList.contains('block-editor-iframe__body'))
        return;

    // Google Maps API loads asynchronously - wait for its callback if it isn't ready yet.
    if (window.google && window.google.maps) {
        googleMapInit();
    } else {
        document.addEventListener('bn-google-maps-loaded', googleMapInit, { once: true });
    }
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootGoogleMap);
} else {
    bootGoogleMap();
}
